export default class changeReportController {
  static ploat (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/change/report/plato', 'get', params, axiosOption, httpOption);
  }

  static dueList (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/change/report/due_list', 'get', params, axiosOption, httpOption);
  }

  static finishRate (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/change/report/finish_rate', 'get', params, axiosOption, httpOption);
  }

}
